var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReferralHandshake = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m26.79 25.183-5.48-3.044M8.732 25.826c1.334 1.287 2.152 2.442 3.055 3.57M34.786 25.88c-.94.907-1.62 1.745-2.257 2.557",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m26.79 25.184 5.496 3.081c.715.4.97 1.307.57 2.02-.401.715-1.307.97-2.021.57l-5.496-3.082M25.335 27.773l4.476 2.51c.714.4.97 1.306.57 2.02-.402.714-1.308.97-2.021.57l-4.476-2.51",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m23.883 30.363 3.486 1.954c.714.4.97 1.306.569 2.02-.4.714-1.307.97-2.02.57l-3.486-1.954M22.432 32.953l2.367 1.327c.714.4.97 1.307.57 2.02-.401.715-1.307.97-2.021.57l-1.654-.926M15.168 17.34l3.546.08c.404.01.805.108 1.169.287l.987.485",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m17.333 36.498 1.842-1.957a1.485 1.485 0 0 1 2.162 2.035l-1.842 1.956a1.485 1.485 0 0 1-2.162-2.034Z",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m15.174 34.465 2.846-3.021a1.485 1.485 0 0 1 2.162 2.034l-2.846 3.02a1.485 1.485 0 0 1-2.162-2.033ZM13.012 32.426l3.095-3.283a1.485 1.485 0 0 1 2.162 2.034l-3.095 3.284a1.485 1.485 0 0 1-2.162-2.035ZM10.85 30.39l2.26-2.398a1.485 1.485 0 0 1 2.161 2.035l-2.26 2.398a1.485 1.485 0 0 1-2.161-2.035ZM21.312 22.139l-1.94 1.121a2.836 2.836 0 0 1-3.883-1.044.79.79 0 0 1 .293-1.08l6.93-3.995a3.19 3.19 0 0 1 2.116-.37l3.57.612",
  stroke: "#5C6471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m5.853 22.534 6.126-8.211a1.07 1.07 0 0 1 1.495-.226l1.68 1.243c.475.35.576 1.02.226 1.495L8.577 26.04a1.07 1.07 0 0 1-1.495.226L4.95 24.689M37.721 22.598l-6.125-8.21a1.07 1.07 0 0 0-1.496-.226l-1.68 1.242a1.07 1.07 0 0 0-.226 1.496l6.803 9.204a1.07 1.07 0 0 0 1.495.226l2.132-1.577",
  stroke: "#A4ABB7",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.79 4.998V10.1M26.174 5.771l-1.748 4.796M30.026 7.998l-3.28 3.91M13.552 7.992l3.28 3.91M17.408 5.77l1.745 4.795",
  stroke: "#F15B35",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M43.5 22c0 11.874-9.626 21.5-21.5 21.5S.5 33.874.5 22 10.126.5 22 .5 43.5 10.126 43.5 22Z",
  stroke: "#A4ABB7"
})));
export default SvgReferralHandshake;